(function () {
  const PIUSA = {
    init() {
      initImageFallbacks();
      initNewsletterGravityFormFallback();
      initChildProfileCards();
      initChildFilterSelects();
    },
  };

  document.addEventListener("DOMContentLoaded", PIUSA.init);

  globalThis.addEventListener("load", () => {
    globalThis.setTimeout(initNewsletterGravityFormFallback, 500);
  });


  function getI18n(key, fallback) {
    if (globalThis.plan_usa_i18n && typeof globalThis.plan_usa_i18n[key] === "string") {
      return globalThis.plan_usa_i18n[key];
    }

    return fallback;
  }

  function initImageFallbacks(root = document) {
    root.querySelectorAll("img[data-fallback-src]").forEach((image) => {
      if (image.dataset.fallbackReady === "true") {
        return;
      }

      image.dataset.fallbackReady = "true";
      image.addEventListener("error", () => {
        const fallbackSrc = image.getAttribute("data-fallback-src");

        if (!fallbackSrc || image.getAttribute("src") === fallbackSrc) {
          return;
        }

        image.setAttribute("src", fallbackSrc);
      });
    });
  }

  function initNewsletterGravityFormFallback() {
    const wrapper = document.getElementById("gform_wrapper_2");

    if (!wrapper || wrapper.dataset.planUsaNewsletterFallbackApplied === "true") {
      return;
    }

    if (wrapper.style.display !== "none") {
      return;
    }

    if (typeof globalThis.gf_apply_rules === "function") {
      wrapper.dataset.planUsaNewsletterFallbackApplied = "true";
      globalThis.gf_apply_rules(2, [0], true);
    } else if (document.readyState !== "complete") {
      return;
    } else {
      wrapper.dataset.planUsaNewsletterFallbackApplied = "true";
    }

    if (globalThis.jQuery) {
      globalThis.jQuery(wrapper).show();
      globalThis.jQuery(wrapper).find("form").css("opacity", "");
      return;
    }

    wrapper.style.display = "";

    const form = document.getElementById("gform_2");

    if (form) {
      form.style.opacity = "";
    }
  }

  function getCurrentLanguageCode() {
    const lang = String(document.documentElement.getAttribute("lang") || "").trim().toLowerCase();

    if (lang === "") {
      return "";
    }

    const normalized = lang.replace("_", "-");

    return normalized.split("-")[0] || "";
  }

  function getGtTranslateKeysHeaderValue() {
    return [
      "message",
      "learnMoreLabel",
      "child.heroHeading",
      "child.heroBlurb",
      "child.heroDescription",
      "child.quickInfo.#.label",
      "child.quickInfo.#.value",
      "child.cta.anchorLabel",
      "child.cta.title",
      "child.cta.description->html",
      "child.cta.summary",
      "child.cta.disabledReason",
      "child.cta.modal.heading",
      "child.cta.modal.intro->html",
      "child.cta.modal.frequencyHeading",
      "child.cta.modal.submitLabel",
      "child.cta.modal.safeguardingPrefix",
      "child.cta.modal.policyLabel",
      "child.cta.modal.duplicateMessage",
      "child.cta.modal.limitMessage",
      "child.cta.modal.closeLabel",
      "child.cta.frequencyOptions.#.label",
    ].join(",");
  }

  function resolveTranslatedEndpointUrl(endpointUrl) {
    if (String(endpointUrl || "").trim() === "") {
      return "";
    }

    let parsed;

    try {
      parsed = new URL(endpointUrl, globalThis.location.origin);
    } catch (error) {
      return endpointUrl;
    }

    const currentLang = getCurrentLanguageCode();

    if (currentLang === "") {
      return parsed.toString();
    }

    const currentPath = String(globalThis.location.pathname || "");
    const langBase = `/${currentLang}`;
    const langPrefix = `${langBase}/`;
    const isTranslatedPath = currentPath === langBase || currentPath.startsWith(langPrefix);

    if (!isTranslatedPath) {
      return parsed.toString();
    }

    if (parsed.pathname === langBase || parsed.pathname.startsWith(langPrefix)) {
      return parsed.toString();
    }

    if (!parsed.pathname.startsWith("/wp-json/")) {
      return parsed.toString();
    }

    parsed.pathname = `${langBase}${parsed.pathname}`;

    return parsed.toString();
  }

  function initChildProfileCards() {
    document.querySelectorAll("[data-child-profile-card]").forEach((card) => {
      initSponsorModal(card);

      if (card.dataset.childProfileCardInitialized === "true") {
        return;
      }

      const form = card.querySelector("[data-child-filter-form]");
      const submitButton = form ? form.querySelector("[data-child-filter-submit]") : null;
      const resetButton = form ? form.querySelector("[data-child-filter-reset]") : null;

      if (!form || !submitButton || card.dataset.filterMode !== "async") {
        card.dataset.childProfileCardInitialized = "true";
        return;
      }

      card.dataset.childProfileCardInitialized = "true";

      form.addEventListener("submit", (event) => {
        event.preventDefault();
      });

      submitButton.addEventListener("click", async () => {
        await refreshCard(card, form, readFilters(form));
      });

      if (resetButton) {
        resetButton.addEventListener("click", async () => {
          clearFilters(form);
          await refreshCard(card, form, readFilters(form));
        });
      }
    });
  }

  function initChildFilterSelects() {
    if (typeof TomSelect !== "function") {
      return;
    }

    document.querySelectorAll(".js-child-filter-select").forEach((select) => {
      if (select.tomselect) {
        return;
      }

      new TomSelect(select, {
        controlInput: null,
        create: false,
        allowEmptyOption: true,
        maxItems: 1,
      });
    });
  }

  async function refreshCard(card, form, nextFilters) {
    const appliedFilters = readAppliedFilters(card);

    if (filtersMatch(nextFilters, appliedFilters)) {
      return;
    }

    setLoadingState(form, true);

    try {
      const payload = await fetchCardPayload(card, form, nextFilters);

      if (!payload || !payload.child) {
        return;
      }

      applyCardPayload(card, form, payload);
    } catch (error) {
      console.error("Unable to refresh child profile card.", error);
    } finally {
      setLoadingState(form, false);
    }
  }

  function initSponsorModal(card) {
    card.querySelectorAll("[data-child-primary-cta]").forEach((cta) => {
      if (cta.dataset.childSponsorModalInitialized === "true") {
        return;
      }

      const modal = cta.querySelector("[data-child-sponsor-modal]");
      const sponsorForm = findSponsorForm(cta);
      const alert = cta.querySelector("[data-child-sponsor-alert]");
      const directSubmit = cta.dataset.directSubmit === "true";

      if (!sponsorForm || !alert || (!modal && !directSubmit)) {
        return;
      }

      cta.dataset.childSponsorModalInitialized = "true";

      setupNativeDialog(modal);
      setupNativeDialog(alert);
      prepareSponsorForm(cta, sponsorForm);
      normalizeGravityModalContent(cta, sponsorForm);
      syncFrequencySelection(sponsorForm);
      syncSafeguardingState(sponsorForm);

      if (isGravitySponsorForm(sponsorForm)) {
        cta.addEventListener("click", async (event) => {
          if (!event.target.closest("[data-child-gravity-form] button[type='submit'], [data-child-gravity-form] input[type='submit'], [data-child-gravity-form] .gform_button")) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          await submitSponsorForm(cta, modal, sponsorForm);
        }, true);

        cta.addEventListener("submit", async (event) => {
          if (!event.target.closest("[data-child-gravity-form]")) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          await submitSponsorForm(cta, modal, sponsorForm);
        }, true);
      }

      cta.addEventListener("click", (event) => {
        if (event.target.closest("[data-child-primary-button]")) {
          prepareSponsorForm(cta, sponsorForm);

          if (directSubmit) {
            submitSponsorForm(cta, null, sponsorForm);
            return;
          }

          const error = validateSponsorForm(cta, sponsorForm);

          if (
            error &&
            !(isGravitySponsorForm(sponsorForm) && ["missing_options", "missing_policy"].includes(error.code))
          ) {
            const isDuplicate = error.code === 'duplicate_child';
            showSponsorAlert(cta, error.message, { isHtml: isDuplicate, type: isDuplicate ? 'info' : 'warning' });
            return;
          }

          openOverlay(modal);
          return;
        }

        if (event.target.closest("[data-child-modal-close]")) {
          closeOverlay(modal);
          return;
        }

        if (event.target.closest("[data-child-alert-close]")) {
          closeOverlay(alert);
        }
      });

      cta.addEventListener("change", (event) => {
        if (event.target.closest("[data-child-gravity-form]")) {
          prepareSponsorForm(cta, sponsorForm);
          normalizeGravityModalContent(cta, sponsorForm);
        }

        if (event.target.matches("[data-child-frequency-option]")) {
          applyFrequencyOption(sponsorForm, event.target);
        }

        if (isSafeguardingCheckbox(event.target)) {
          syncSafeguardingState(sponsorForm);
        }
      });

      sponsorForm.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (isGravitySponsorForm(sponsorForm)) {
          event.stopImmediatePropagation();
        }

        await submitSponsorForm(cta, modal, sponsorForm);
      }, true);
    });
  }

  async function submitSponsorForm(cta, modal, sponsorForm) {
    const submitButton = findSponsorSubmitButton(sponsorForm);
    prepareSponsorForm(cta, sponsorForm);
    const error = validateSponsorForm(cta, sponsorForm);

    if (error) {
      closeOverlay(modal);
      const isDuplicate = error.code === 'duplicate_child';
      showSponsorAlert(cta, error.message, { isHtml: isDuplicate, type: isDuplicate ? 'info' : 'warning' });
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
    }

    const sponsorController = getSponsorChildController();

    if (!sponsorController || typeof sponsorController.sponsorshipFormSubmit !== "function") {
      if (submitButton) {
        submitButton.disabled = false;
      }

      console.error("SponsorChildForm controller is unavailable.");
      return;
    }

    let result;

    try {
      result = await sponsorController.sponsorshipFormSubmit(sponsorForm);
    } catch (error) {
      console.error("Sponsor form submit failed.", error);
      result = {
        ok: false,
        error: {
          message: getI18n("unable_to_add", "Unable to add this child to your cart."),
        },
      };
    }

    if (result && result.ok === false) {
      if (submitButton) {
        submitButton.disabled = false;
      }

      closeOverlay(modal);
      const isDuplicate = result.error?.code === 'duplicate_child';
      showSponsorAlert(
        cta,
        result.error?.message || cta.dataset.duplicateMessage || buildDuplicateMessage(""),
        { isHtml: isDuplicate, type: isDuplicate ? 'info' : 'warning' }
      );
      return;
    }

    if (submitButton) {
      submitButton.disabled = false;
    }

    closeOverlay(modal);
    showSponsorSuccess(cta, result?.item?.options?.child_name || "");
  }

  function findSponsorSubmitButton(form) {
    const submitButton = form.querySelector(
      "[data-child-modal-submit], .gform_button[type='submit'], .gform_footer input[type='submit'], .gform_footer button[type='submit'], button[type='submit'], input[type='submit']",
    );

    if (submitButton) {
      return submitButton;
    }

    return form.closest("[data-child-primary-cta]")?.querySelector("[data-child-primary-button]") || null;
  }

  function findSponsorForm(cta) {
    const customForm = cta.querySelector("[data-child-modal-form]");

    if (customForm) {
      return customForm;
    }

    const gravityForm = cta.querySelector("[data-child-gravity-form] form");

    if (gravityForm) {
      gravityForm.setAttribute("data-child-modal-form", "");
    }

    return gravityForm;
  }

  function prepareSponsorForm(cta, form) {
    if (!form || !isGravitySponsorForm(form)) {
      return;
    }

    const gravityWrapper = form.closest("[data-child-gravity-form]");
    const formName = gravityWrapper?.dataset.formName || cta.dataset.formName || getI18n("child_sponsorship", "Child sponsorship");
    const postId = gravityWrapper?.dataset.postId || cta.dataset.postId || cta.dataset.gravityFormId || "";
    const childSfid = gravityWrapper?.dataset.childSfid || cta.dataset.childSfid || "";
    const childName = gravityWrapper?.dataset.childName || cta.dataset.childName || "";
    const childCountry = gravityWrapper?.dataset.childCountry || cta.dataset.childCountry || "";
    const childImage = gravityWrapper?.dataset.childImage || cta.dataset.childImage || "";

    setInputValue(form, "postID", postId || readGravityFieldValue(form, "postID"));
    setInputValue(form, "form_name", formName || readGravityFieldValue(form, "form_name"));
    setInputValue(form, "name", formName || readGravityFieldValue(form, "name"));
    setInputValue(form, "child_id", childSfid);
    setInputValue(form, "child_salesforce_id", childSfid);
    setInputValue(form, "child_name", childName);
    setInputValue(form, "child_country", childCountry);
    setInputValue(form, "image", childImage);
    updateGravityTitle(form, childName);
    updateSponsorSubmitButton(form, childName);
    setInputValue(form, "quantity", "1");
    setInputValue(form, "continue", "0");
    syncGravityFrequencySelection(form);
    setInputValue(form, "form_id", readGravityFieldValue(form, "form_id") || readInputValue(form, "form_id"));
    setInputValue(form, "amount", readGravityFieldValue(form, "amount") || readInputValue(form, "amount"));
    setInputValue(form, "level-id", readGravityFieldValue(form, "level-id") || readInputValue(form, "level-id"));
    setInputValue(form, "opts", readGravityFieldValue(form, "opts") || readInputValue(form, "opts"));
    setInputValue(
      form,
      "installment_frequency",
      readGravityFieldValue(form, "installment_frequency") || readInputValue(form, "installment_frequency"),
    );
    setInputValue(form, "abstract", readGravityFieldValue(form, "abstract") || readInputValue(form, "abstract"));
  }

  function readFilters(form) {
    return {
      gender: readInputValue(form, "child_gender"),
      age: readInputValue(form, "child_age"),
      country: readInputValue(form, "child_country"),
    };
  }

  function readAppliedFilters(card) {
    return {
      gender: card.dataset.appliedGender || "",
      age: card.dataset.appliedAge || "",
      country: card.dataset.appliedCountry || "",
    };
  }

  function filtersMatch(left, right) {
    return left.gender === right.gender && left.age === right.age && left.country === right.country;
  }

  function readInputValue(form, name) {
    const input = form.querySelector(`[name='${name}']`);

    return input ? String(input.value || "") : "";
  }

  async function fetchCardPayload(card, form, filters) {
    if (!form) {
      throw new Error("Missing child profile form.");
    }

    const endpointUrl = resolveTranslatedEndpointUrl(
      form.dataset.filterEndpointUrl || card.dataset.filterEndpointUrl || ""
    );

    if (endpointUrl === "") {
      throw new Error(getI18n("missing_endpoint", "Missing child profile endpoint URL."));
    }

    const params = new URLSearchParams();
    const baseProductId = form.dataset.baseProductId || card.dataset.baseProductId || "";
    const currentPageUrl = card.dataset.currentPageUrl || form.getAttribute("action") || globalThis.location.href;
    const defaultChildSource = form.dataset.defaultChildSource || card.dataset.defaultChildSource || "global";
    const excludeBaseProductFromMatches =
      (form.dataset.excludeBaseProductFromMatches || card.dataset.excludeBaseProductFromMatches || "0") === "1";
    const formId = form.dataset.formId || card.dataset.formId || "";
    const gravityFormId = form.dataset.gravityFormId || card.dataset.gravityFormId || "";

    if (baseProductId !== "" && baseProductId !== "0") {
      params.set("product_id", baseProductId);
    }

    if (currentPageUrl !== "") {
      params.set("current_page_url", currentPageUrl);
    }

    params.set("default_child_source", defaultChildSource);

    if (excludeBaseProductFromMatches) {
      params.set("exclude_base_product_from_matches", "1");
    }

    if (formId !== "" && formId !== "0") {
      params.set("form_id", formId);
    }

    if (gravityFormId !== "" && gravityFormId !== "0") {
      params.set("gravity_form_id", gravityFormId);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "") {
        params.set(`child_${key}`, value);
      }
    });

    const headers = {
      Accept: "application/json",
      "X-GT-Translate-Keys": getGtTranslateKeysHeaderValue(),
    };
    const currentLang = getCurrentLanguageCode();

    if (currentLang !== "") {
      let endpointPath = "";

      try {
        endpointPath = new URL(endpointUrl, globalThis.location.origin).pathname || "";
      } catch {
        endpointPath = "";
      }

      const langSeg = `/${currentLang}`;
      const langPrefixed =
        endpointPath === langSeg || endpointPath === `${langSeg}/` || endpointPath.startsWith(`${langSeg}/`);

      if (!langPrefixed) {
        headers["X-GT-Lang"] = currentLang;
      }
    }

    const response = await fetch(`${endpointUrl}?${params.toString()}`, {
      credentials: "same-origin",
      headers,
    });

    if (!response.ok) {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

    return response.json();
  }

  function applyCardPayload(card, form, payload) {
    const child = payload.child || {};
    const filters = payload.filters || { gender: "", age: "", country: "" };

    updateChildName(
      card.querySelector("[data-child-name]"),
      buildChildNameHeading(child.heroHeading || "", child.name || "")
    );
    updateImage(card.querySelector("[data-child-image]"), child.imageUrl || "", child.imageAlt || child.name || "");
    updateWaitingDays(card, child.daysWaiting || "");
    updateMessage(card, payload.message || "");
    updateBlurb(card, child.heroBlurb || "");
    updateDescription(card, child.heroDescription || "");
    updateQuickInfo(card, child.quickInfo || []);
    updateCta(card, child, payload);
    updateFilterState(card, form, filters, payload);
  }

  function buildChildNameHeading(heroHeading, childName) {
    const normalizedHeading = String(heroHeading || "").trim();

    if (normalizedHeading !== "") {
      return normalizedHeading;
    }

    const firstName = String(childName || "").trim().split(/\s+/)[0];

    if (firstName === "") {
      return "";
    }

    const template = getI18n("my_name_is_template", "My name is %s");

    if (template.includes("%s")) {
      return template.replace("%s", firstName);
    }

    return `${template} ${firstName}`;
  }

  function updateImage(image, src, alt) {
    if (!image) {
      return;
    }

    image.setAttribute("src", src);
    image.setAttribute("alt", alt);
  }

  function updateWaitingDays(card, daysWaiting) {
    const waiting = card.querySelector("[data-child-waiting]");
    const value = card.querySelector("[data-child-waiting-value]");

    if (!waiting || !value) {
      return;
    }

    const hasValue = String(daysWaiting) !== "";

    waiting.hidden = !hasValue;
    value.textContent = hasValue ? String(daysWaiting) : "";
  }

  function updateMessage(card, message) {
    const notice = card.querySelector("[data-child-message]");

    if (!notice) {
      return;
    }

    const hasMessage = String(message) !== "";

    notice.hidden = !hasMessage;

    // Write into the inner chip element when present (child-filter-message layout),
    // falling back to the notice element itself for legacy single-element usage.
    const chip = notice.querySelector(".child-filter-message__chip");
    (chip || notice).textContent = hasMessage ? String(message) : "";
  }

  function updateBlurb(card, blurb) {
    const target = card.querySelector("[data-child-blurb]");

    if (!target) {
      return;
    }

    const hasBlurb = String(blurb) !== "";

    target.hidden = !hasBlurb;
    target.textContent = hasBlurb ? String(blurb) : "";
  }

  function updateDescription(card, description) {
    const target = card.querySelector("[data-child-description]");

    if (!target) {
      return;
    }

    const hasDescription = String(description) !== "";

    target.hidden = !hasDescription;
    target.textContent = hasDescription ? String(description) : "";
  }

  function updateQuickInfo(card, items) {
    const summary = card.querySelector("[data-child-quick-info]");

    if (!summary) {
      return;
    }

    summary.innerHTML = "";
    summary.hidden = !Array.isArray(items) || items.length === 0;

    if (summary.hidden) {
      return;
    }

    items.forEach((item) => {
      const chip = document.createElement("div");
      chip.className = "child-product-chip";

      const label = document.createElement("span");
      label.className = "child-product-chip__label";
      label.textContent = item.label || "";

      const value = document.createElement("span");
      value.className = "child-product-chip__value";
      value.textContent = item.value || "";

      chip.appendChild(label);
      chip.appendChild(value);
      summary.appendChild(chip);
    });
  }

  function updateCta(card, child, payload) {
    const cta = child.cta || {};
    const summary = card.querySelector("[data-child-cta-summary]");
    const primaryCta = card.querySelector("[data-child-primary-cta]");
    const unavailable = card.querySelector("[data-child-cta-unavailable]");
    const learnMoreLink = card.querySelector("[data-child-learn-more]");
    const learnMoreLabel = card.querySelector("[data-child-learn-more-label]");

    if (summary) {
      const hasSummary = String(cta.summary || "") !== "";
      summary.hidden = !hasSummary;
      summary.textContent = hasSummary ? String(cta.summary) : "";
    }

    if (primaryCta) {
      const enabled = Boolean(cta.enabled);
      const sponsorForm = findSponsorForm(primaryCta);
      const sponsorModal = primaryCta.querySelector("[data-child-sponsor-modal]");
      const sponsorAlert = primaryCta.querySelector("[data-child-sponsor-alert]");

      primaryCta.hidden = !enabled;
      primaryCta.dataset.childSfid = child.sfid || "";
      primaryCta.dataset.childName = child.name || "";
      primaryCta.dataset.childCountry = child.country || "";
      primaryCta.dataset.childImage = child.imageUrl || "";
      primaryCta.dataset.formName = cta.formName || primaryCta.dataset.formName || getI18n("child_sponsorship", "Child sponsorship");
      primaryCta.dataset.postId = String(cta.postId || primaryCta.dataset.gravityFormId || "");
      primaryCta.dataset.policyUrl = String(cta.policyLink?.url || "");
      primaryCta.dataset.policyTarget = String(cta.policyLink?.target || "_self");
      primaryCta.dataset.policyLabel = decodeHtmlEntities(cta.modal?.policyLabel || cta.policyLink?.title || getI18n("safeguarding_policy", "Plan's safeguarding policy"));
      primaryCta.dataset.frequencyHeading = String(cta.modal?.frequencyHeading || getI18n("sponsorship_frequency", "Sponsorship frequency"));
      primaryCta.dataset.duplicateMessage =
        cta.modal?.duplicateMessage || buildDuplicateMessage(child.name || "");
      primaryCta.dataset.limitMessage =
        cta.modal?.limitMessage || getI18n("limit_message", "You can only sponsor 10 children at a time.");

      updateText(primaryCta.querySelector("[data-child-primary-label]"), cta.anchorLabel || getI18n("sponsor_this_child", "Sponsor this child"));
      updateText(primaryCta.querySelector("[data-child-modal-title]"), cta.modal?.heading || cta.anchorLabel || getI18n("sponsor_this_child", "Sponsor this child"));
      updateText(primaryCta.querySelector("[data-child-modal-intro]"), cta.modal?.intro || "");
      updateText(
        primaryCta.querySelector("[data-child-modal-submit-label]"),
        cta.modal?.submitLabel || cta.anchorLabel || getI18n("sponsor_this_child", "Sponsor this child"),
      );
      updateText(
        primaryCta.querySelector("[data-child-frequency-heading]"),
        cta.modal?.frequencyHeading || getI18n("sponsorship_frequency", "Sponsorship frequency"),
      );

      updatePolicy(primaryCta, cta);

      if (sponsorForm) {
        const defaultOption = cta.defaultOption || {};
        const gravityWrapper = sponsorForm.closest("[data-child-gravity-form]");

        if (gravityWrapper) {
          gravityWrapper.dataset.childSfid = child.sfid || "";
          gravityWrapper.dataset.childName = child.name || "";
          gravityWrapper.dataset.childCountry = child.country || "";
          gravityWrapper.dataset.childImage = child.imageUrl || "";
          gravityWrapper.dataset.formName = cta.formName || getI18n("child_sponsorship", "Child sponsorship");
          gravityWrapper.dataset.postId = String(cta.postId || primaryCta.dataset.gravityFormId || "");
        }

        if (isGravitySponsorForm(sponsorForm)) {
          prepareSponsorForm(primaryCta, sponsorForm);
          normalizeGravityModalContent(primaryCta, sponsorForm);
        } else {
          setInputValue(sponsorForm, "postID", cta.postId || "");
          setInputValue(sponsorForm, "form_name", cta.formName || "");
          setInputValue(sponsorForm, "name", cta.formName || "");
          setInputValue(sponsorForm, "form_id", cta.formId || "");
          setInputValue(sponsorForm, "abstract", cta.abstract || "");
          setInputValue(sponsorForm, "child_id", child.sfid || "");
          setInputValue(sponsorForm, "child_salesforce_id", child.sfid || "");
          setInputValue(sponsorForm, "child_name", child.name || "");
          setInputValue(sponsorForm, "child_country", child.country || "");
          setInputValue(sponsorForm, "amount", defaultOption.amount || cta.amount || "");
          setInputValue(sponsorForm, "level-id", defaultOption.levelId || cta.levelId || "");
          setInputValue(sponsorForm, "opts", defaultOption.opts || cta.opts || "");
          setInputValue(sponsorForm, "image", child.imageUrl || "");
          setInputValue(
            sponsorForm,
            "installment_frequency",
            defaultOption.frequency || cta.installmentFrequency || "",
          );

          rebuildFrequencyOptions(primaryCta, sponsorForm, cta);
          syncFrequencySelection(sponsorForm);
        }
        syncSafeguardingState(sponsorForm);
      }

      closeOverlay(sponsorModal);
      closeOverlay(sponsorAlert);
    }

  if (unavailable) {
    unavailable.hidden = Boolean(cta.enabled);

    if (!cta.enabled) {
      unavailable.textContent = cta.disabledReason || getI18n("not_configured", "Sponsorship is not configured for this child yet.");
    }
  }

    if (learnMoreLink) {
      const href = String(payload.learnMoreUrl || "");
      const hasHref = href !== "";

      learnMoreLink.hidden = !hasHref;
      learnMoreLink.setAttribute("href", hasHref ? href : "#");
    }

    if (learnMoreLabel) {
      learnMoreLabel.textContent = payload.learnMoreLabel || getI18n("learn_more", "Learn more");
    }
  }

  function updatePolicy(primaryCta, cta) {
    const policyWrap = primaryCta.querySelector("[data-child-policy]");
    const policyLink = primaryCta.querySelector("[data-child-policy-link]");
    const policyLabel = primaryCta.querySelector("[data-child-policy-label]");

    if (!policyWrap || !policyLink || !policyLabel) {
      return;
    }

    const url = String(cta.policyLink?.url || "");
    const target = String(cta.policyLink?.target || "_self");
    const label = decodeHtmlEntities(cta.modal?.policyLabel || cta.policyLink?.title || getI18n("safeguarding_policy", "Plan's safeguarding policy"));

    policyWrap.hidden = url === "";
    policyLink.setAttribute("href", url || "#");
    policyLink.setAttribute("target", target);
    policyLabel.textContent = label;
  }

  function normalizeGravityModalContent(cta, form) {
    if (!cta || !isGravitySponsorForm(form)) {
      return;
    }

    form.querySelectorAll(".gfield--type-html").forEach((field) => {
      field.hidden = true;
    });

    const frequencyHeading = cta.dataset.frequencyHeading || getI18n("sponsorship_frequency", "Sponsorship frequency");
    const frequencyField = form.querySelector(".plan-gf-frequency");
    const frequencyLabel = frequencyField
      ? frequencyField.querySelector(".gfield_label, legend")
      : null;

    if (frequencyLabel) {
      frequencyLabel.textContent = frequencyHeading;
    }

    const policyField = findSafeguardingField(form);
    const policy = readPolicyConfig(cta);

    if (!policyField) {
      return;
    }

    policyField.classList.add("plan-gf-safeguarding");

    const label = policyField.querySelector(".gchoice label, .gfield-choice-input + label");

    if (!label) {
      return;
    }

    label.textContent = `${getI18n("agree_to", "I agree to")} `;

    const link = document.createElement("a");
    link.href = policy.url || "#";
    link.target = policy.target || "_self";
    link.textContent = decodeHtmlEntities(policy.label || getI18n("safeguarding_policy", "Plan's safeguarding policy"));
    label.appendChild(link);
    label.appendChild(document.createTextNode("."));
  }

  function readPolicyConfig(cta) {
    return {
      url: String(cta?.dataset.policyUrl || ""),
      target: String(cta?.dataset.policyTarget || "_self"),
      label: decodeHtmlEntities(cta?.dataset.policyLabel || getI18n("safeguarding_policy", "Plan's safeguarding policy")),
    };
  }

  function rebuildFrequencyOptions(primaryCta, sponsorForm, cta) {
    const list = primaryCta.querySelector("[data-child-frequency-options]");

    if (!list) {
      return;
    }

    const fieldset = list.closest(".child-sponsor-modal__frequencies");
    const options = Array.isArray(cta.frequencyOptions) ? cta.frequencyOptions : [];
    const defaultOpts = String(cta.defaultOption?.opts || cta.opts || "");
    const fieldName = primaryCta.dataset.frequencyFieldName || "child_frequency_option";

    list.innerHTML = "";

    if (!options.length) {
      if (fieldset) {
        fieldset.hidden = true;
      }

      return;
    }

    if (fieldset) {
      fieldset.hidden = false;
    }

    options.forEach((option, index) => {
      const label = document.createElement("label");
      label.className = "child-sponsor-modal__frequency-option";

      const input = document.createElement("input");
      input.type = "radio";
      input.name = fieldName;
      input.value = option.opts || "";
      input.setAttribute("data-child-frequency-option", "");
      input.dataset.amount = String(option.amount || "");
      input.dataset.levelId = String(option.levelId || "");
      input.dataset.installmentFrequency = String(option.frequency || "");
      input.dataset.opts = String(option.opts || "");
      input.checked = (option.opts || "") === defaultOpts || (defaultOpts === "" && index === 0);

      const text = document.createElement("span");
      text.textContent = option.label || "";

      label.appendChild(input);
      label.appendChild(text);
      list.appendChild(label);
    });

    syncFrequencySelection(sponsorForm);
  }

  function syncFrequencySelection(form) {
    const checkedOption =
      form.querySelector("[data-child-frequency-option]:checked") ||
      form.querySelector("[data-child-frequency-option]");

    if (!checkedOption) {
      return;
    }

    checkedOption.checked = true;
    applyFrequencyOption(form, checkedOption);
  }

  function applyFrequencyOption(form, input) {
    setInputValue(form, "amount", input.dataset.amount || "");
    setInputValue(form, "level-id", input.dataset.levelId || "");
    setInputValue(form, "opts", input.dataset.opts || input.value || "");
    setInputValue(form, "installment_frequency", input.dataset.installmentFrequency || "");
  }

  function isGravitySponsorForm(form) {
    return Boolean(form && form.closest("[data-child-gravity-form]"));
  }

  function syncGravityFrequencySelection(form) {
    if (!isGravitySponsorForm(form)) {
      return;
    }

    const checkedOption =
      form.querySelector(".plan-gf-frequency input[type='radio']:checked") ||
      form.querySelector(".plan-gf-frequency input[type='radio']");

    if (!checkedOption) {
      return;
    }

    checkedOption.checked = true;
    const parsed = parseGravityFrequencyValue(checkedOption.value || "", checkedOption);

    if (!parsed) {
      return;
    }

    setInputValue(form, "amount", parsed.amount);
    setInputValue(form, "level-id", parsed.levelId);
    setInputValue(form, "opts", parsed.opts);
    setInputValue(form, "installment_frequency", parsed.frequency);
  }

  function inferGravityFrequencyFromInput(input, fallbackValue = "") {
    const candidates = [];

    if (input) {
      candidates.push(input.dataset.installmentFrequency || "");
      candidates.push(input.id || "");
      candidates.push(input.value || "");

      const label = input.closest("label") || document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        candidates.push(label.textContent || "");
      }
    }

    candidates.push(fallbackValue);

    for (const candidate of candidates) {
      const normalized = normalizeGravityFrequency(candidate);
      if (normalized === "monthly" || normalized === "quarterly" || normalized === "annually") {
        return normalized;
      }
    }

    return "";
  }

  function parseGravityFrequencyValue(value, input = null) {
    const parts = String(value || "").split("|").map((part) => part.trim());

    if (parts.length < 2 || parts[0] === "" || parts[1] === "") {
      return null;
    }

    const amount = normalizeGravityAmount(parts[0]);
    const frequency = parts.length >= 4
      ? normalizeGravityFrequency(parts[3])
      : inferGravityFrequencyFromInput(input, value);

    if (!amount || !frequency) {
      return null;
    }

    return {
      amount,
      levelId: parts[1],
      opts: parts[2] || value,
      frequency,
    };
  }

  function normalizeGravityAmount(value) {
    const rawValue = String(value || "").trim();

    if (rawValue === "") {
      return "";
    }

    const amountMatch = rawValue.match(/\d+(?:\.\d+)?/);

    if (!amountMatch) {
      return "";
    }

    if (amountMatch[0].includes(".")) {
      return String(Math.round(Number(amountMatch[0]) * 100));
    }

    return amountMatch[0];
  }

  function normalizeGravityFrequency(value) {
    const frequency = String(value || "").trim().toLowerCase();

    if (frequency.includes("month")) {
      return "monthly";
    }

    if (frequency.includes("quarter")) {
      return "quarterly";
    }

    if (frequency.includes("annual") || frequency.includes("year")) {
      return "annually";
    }

    return frequency;
  }

  function readGravityFieldValue(form, name) {
    const input = findGravityFieldInput(form, name);

    return input ? String(input.value || "") : "";
  }

  function findGravityFieldInput(form, name) {
    const className = gravityFieldClassForName(name);

    if (!className) {
      return null;
    }

    return form.querySelector(`.${className} input, .${className} select, .${className} textarea`);
  }

  function gravityFieldClassForName(name) {
    const map = {
      postID: "plan-gf-post-id",
      form_name: "plan-gf-form-name",
      name: "plan-gf-form-name",
      form_id: "plan-gf-lo-form-id",
      abstract: "plan-gf-abstract",
      child_id: "plan-gf-child-id",
      child_salesforce_id: "plan-gf-child-salesforce-id",
      child_name: "plan-gf-child-name",
      child_country: "plan-gf-child-country",
      amount: "plan-gf-amount",
      "level-id": "plan-gf-level-id",
      opts: "plan-gf-opts",
      image: "plan-gf-image",
      installment_frequency: "plan-gf-installment-frequency",
    };

    return map[name] || "";
  }

  function updateGravityTitle(form, childName) {
    const titleField = form.querySelector(".plan-gf-title");

    if (!titleField) {
      return;
    }

    const firstName = String(childName || "").trim().split(/\s+/)[0];
    const title = `Sponsor ${firstName || getI18n("this_child_lower", "this child")}`;
    const input = titleField.querySelector("input, textarea");

    if (input) {
      input.value = title;
    }

    const textTarget = titleField.querySelector(".gfield_html, .gsection_title, .gfield_label, legend");

    if (textTarget) {
      textTarget.textContent = title;
      return;
    }

    if (!input) {
      titleField.textContent = title;
    }
  }

  function updateSponsorSubmitButton(form, childName) {
    const submitButton = findSponsorSubmitButton(form);

    if (!submitButton) {
      return;
    }

    const firstName = String(childName || "").trim().split(/\s+/)[0];
    const label = `Sponsor ${firstName || getI18n("this_child_lower", "this child")}`;

    // Gravity Forms 2.x rendered the submit control as
    // <input type="submit" value="Label">; 3.0 renders <button>Label</button>,
    // where `value` is no longer the visible label.
    if (submitButton.tagName === "INPUT") {
      submitButton.value = label;
      return;
    }

    const labelTarget = submitButton.querySelector("[data-child-modal-submit-label]") || submitButton;

    labelTarget.textContent = label;
  }

  function syncSafeguardingState(form) {
    const checkbox = findSafeguardingCheckbox(form);
    const submitButton = findSponsorSubmitButton(form);

    if (!submitButton) {
      return;
    }

    submitButton.disabled = checkbox ? !checkbox.checked : false;
  }

  function validateSponsorForm(cta, sponsorForm) {
    const gravityError = validateGravitySponsorFields(sponsorForm);

    if (gravityError) {
      return gravityError;
    }

    const sponsorController = getSponsorChildController();

    if (sponsorController && typeof sponsorController.validateSponsorshipForm === "function") {
      const validation = sponsorController.validateSponsorshipForm(sponsorForm);

      if (validation && validation.ok === false) {
        return {
          code: validation.error?.code || "invalid",
          message: validation.error?.message || cta.dataset.duplicateMessage || buildDuplicateMessage(""),
        };
      }

      return null;
    }

    const formData = new FormData(sponsorForm);

    if (!hasRequiredSponsorshipFields(sponsorForm, formData)) {
      return {
        code: "missing_options",
        message: getI18n("missing_attributes", "Missing required attributes."),
      };
    }

    const childId = String(formData.get("child_id") || formData.get("child_salesforce_id") || "");
    const childName = String(formData.get("child_name") || "");
    const cartItems = expireStoredSponsorshipCartItems();
    const sponsorshipItems = Object.values(cartItems).filter((item) => {
      return item && item.options && item.options.item_type === "SponsorshipCartItem";
    });

    const duplicate = sponsorshipItems.find((item) => {
      return String(item.options?.child_id || "") === childId;
    });

    if (duplicate) {
      return {
        code: "duplicate_child",
        message: cta.dataset.duplicateMessage || buildDuplicateMessage(childName),
      };
    }

    if (sponsorshipItems.length >= 10) {
      return {
        code: "cart_limit",
        message: cta.dataset.limitMessage || getI18n("limit_message", "You can only sponsor 10 children at a time."),
      };
    }

    return null;
  }

  function validateGravitySponsorFields(form) {
    if (!isGravitySponsorForm(form)) {
      return null;
    }

    const policyField = findSafeguardingField(form);

    if (!policyField) {
      return null;
    }

    const checkedPolicy = policyField.querySelector("input[type='checkbox']:checked");

    if (!checkedPolicy) {
      return {
        code: "missing_policy",
        message: getI18n("agree_to_policy", "Please agree to Plan's safeguarding policy."),
      };
    }

    return null;
  }

  function findSafeguardingField(form) {
    return (
      form.querySelector(".plan-gf-safeguarding") ||
      form.querySelector(".gfield_contains_required.gfield--type-checkbox")
    );
  }

  function findSafeguardingCheckbox(form) {
    const customCheckbox = form.querySelector("[data-child-safeguarding-checkbox]");

    if (customCheckbox) {
      return customCheckbox;
    }

    const policyField = findSafeguardingField(form);

    return policyField ? policyField.querySelector("input[type='checkbox']") : null;
  }

  function isSafeguardingCheckbox(target) {
    if (!target || !target.matches("input[type='checkbox']")) {
      return false;
    }

    return Boolean(
      target.matches("[data-child-safeguarding-checkbox]") ||
      target.closest(".plan-gf-safeguarding, .gfield_contains_required.gfield--type-checkbox"),
    );
  }

  function getSponsorChildController() {
    if (typeof globalThis.SponsorChildForm === "function") {
      return globalThis.SponsorChildForm();
    }

    return {
      validateSponsorshipForm(form) {
        return validateSponsorshipFormFallback(form);
      },
      sponsorshipFormSubmit(form, keepShopping = false) {
        return sponsorshipFormSubmitFallback(form, keepShopping);
      },
    };
  }

  function buildDuplicateMessage(childName) {
    const firstName = String(childName || '').trim().split(/\s+/)[0];
    const name = firstName || getI18n("this_child_lower", "this child");

    const title = `You've already added ${escapeHtml(name)} to your sponsorship cart.`;
    const body  = `Each child can only be added once. You can review or update this sponsorship before checking out.`;

    return `<strong class="child-sponsor-alert__message-title">${title}</strong>`
         + `<p class="child-sponsor-alert__message-body">${body}</p>`;
  }

  function getSponsorCartSource(form) {
    const source = String(form?.dataset?.cartSource || readSponsorDatasetValue(form, "cartSource") || "");

    if (source === "gravity_forms" || source === "donation_form") {
      return source;
    }

    return isGravitySponsorForm(form) ? "gravity_forms" : "donation_form";
  }

  function hasRequiredSponsorshipFields(form, formData) {
    if (getSponsorCartSource(form) !== "gravity_forms") {
      return String(formData.get("opts") || "") !== "";
    }

    const childId = getChildSalesforceId(formData);
    const childName = String(formData.get("child_name") || "");
    const formId = String(formData.get("form_id") || readSponsorDatasetValue(form, "formId") || readSponsorDatasetValue(form, "gravityFormId") || "");
    const levelId = String(formData.get("level-id") || "");
    const frequency = String(formData.get("installment_frequency") || "");
    const amount = normalizeAmountToCents(formData.get("amount"));

    return Boolean(childId && childName && formId && levelId && frequency && amount > 0);
  }

  function validateSponsorshipFormFallback(form) {
    const formData = new FormData(form);
    const childId = getChildSalesforceId(formData);
    const childName = String(formData.get("child_name") || "");

    if (!hasRequiredSponsorshipFields(form, formData)) {
      return {
        ok: false,
        error: {
          code: "missing_options",
          message: getI18n("missing_attributes", "Missing required attributes."),
        },
      };
    }

    const sponsorshipItems = getStoredSponsorshipItems();
    const duplicate = sponsorshipItems.find((item) => {
      return String(item.options?.child_id || "") === childId;
    });

    if (duplicate) {
      return {
        ok: false,
        error: {
          code: "duplicate_child",
          message: buildDuplicateMessage(childName),
        },
      };
    }

    if (sponsorshipItems.length >= 10) {
      return {
        ok: false,
        error: {
          code: "cart_limit",
          message: getI18n("limit_message", "You can only sponsor 10 children at a time."),
        },
      };
    }

    return {
      ok: true,
      error: null,
    };
  }

  async function sponsorshipFormSubmitFallback(form, keepShopping = false) {
    const validation = validateSponsorshipFormFallback(form);

    if (!validation.ok) {
      resetSponsorButtonState(form);
      return {
        ok: false,
        error: validation.error,
      };
    }

    const item = buildSponsorshipCartItem(form);
    const cartItems = storeSponsorshipCartItem(item);

    pushSponsorshipAddToCart(item);

    if (!keepShopping) {
      const syncResult = await syncCartItemsToServer(cartItems, item.uuid);

      if (syncResult && syncResult.status === "error") {
        resetSponsorButtonState(form);
        return {
          ok: false,
          error: {
            code: "cart_sync_failed",
            message: Array.isArray(syncResult.message) ? syncResult.message.join(" ") : getI18n("unable_to_add", "Unable to add this child to your cart."),
          },
        };
      }
    }

    resetSponsorButtonState(form);

    return {
      ok: true,
      item,
    };
  }

  function resetSponsorButtonState(form) {
    const disabledButtons = form ? form.querySelectorAll("button[disabled]") : [];

    disabledButtons.forEach((button) => {
      button.disabled = false;
    });

    if (form && form.__x && form.__x.$data && Object.prototype.hasOwnProperty.call(form.__x.$data, "buttonDisabled")) {
      form.__x.$data.buttonDisabled = false;
    }
  }

  function buildSponsorshipCartItem(form) {
    const formData = new FormData(form);
    const uuid = generateCartItemUuid();

    return {
      name: formData.get("form_name") || readSponsorDatasetValue(form, "formName"),
      quantity: "1",
      uuid,
      amount: normalizeAmountToCents(formData.get("amount")),
      postID: formData.get("postID") || readSponsorDatasetValue(form, "postId"),
      options: {
        lo_form_id: formData.get("form_id") || readSponsorDatasetValue(form, "formId") || readSponsorDatasetValue(form, "gravityFormId"),
        lo_level_id: formData.get("level-id"),
        child_id: getChildSalesforceId(formData),
        child_salesforce_id: getChildSalesforceId(formData),
        child_name: formData.get("child_name"),
        child_country: formData.get("child_country") || readSponsorDatasetValue(form, "childCountry"),
        image: formData.get("image"),
        abstract: formData.get("abstract"),
        frequency_options: readSponsorshipFrequencyOptions(form),
        installment_frequency: String(formData.get("installment_frequency") || "").toLowerCase(),
        cart_source: getSponsorCartSource(form),
        lock_start: Date.now(),
        item_type: "SponsorshipCartItem",
      },
    };
  }

  function readSponsorshipFrequencyOptions(form) {
    const inputs = isGravitySponsorForm(form)
      ? Array.from(form.querySelectorAll(".plan-gf-frequency input[type='radio']"))
      : Array.from(form.querySelectorAll("[data-child-frequency-option]"));

    return inputs
      .map((input) => {
        if (isGravitySponsorForm(form)) {
          const parsed = parseGravityFrequencyValue(input.value || "", input);

          if (!parsed) {
            return null;
          }

          return {
            amount: normalizeAmountToCents(parsed.amount),
            levelId: parsed.levelId,
            "level-id": parsed.levelId,
            frequency: parsed.frequency,
            opts: parsed.opts,
          };
        }

        const amount = normalizeAmountToCents(input.dataset.amount || "");
        const levelId = input.dataset.levelId || "";
        const frequency = String(input.dataset.installmentFrequency || "").toLowerCase();

        if (!amount || !levelId || !frequency) {
          return null;
        }

        return {
          amount,
          levelId,
          "level-id": levelId,
          frequency,
          opts: input.dataset.opts || input.value || "",
        };
      })
      .filter(Boolean);
  }

  function normalizeAmountToCents(amount) {
    if (typeof amount === "number" && Number.isFinite(amount)) {
      return Math.round(amount);
    }

    const rawAmount = String(amount || "").trim();

    if (!rawAmount) {
      return 0;
    }

    const numericAmount = Number(rawAmount.replace(/[^0-9.-]/g, ""));

    if (!Number.isFinite(numericAmount)) {
      return 0;
    }

    if (rawAmount.includes(".") || rawAmount.includes("$")) {
      return Math.round(numericAmount * 100);
    }

    return Math.round(numericAmount);
  }

  function storeSponsorshipCartItem(item) {
    const cartItems = expireStoredSponsorshipCartItems();
    const nextItems = { ...cartItems, [item.uuid]: item };
    setStoredCartItems(nextItems);

    const nextQty = getCartItemsQuantity(nextItems);
    localStorage.setItem(CART_QUANTITY_STORAGE_KEY, String(nextQty));
    syncCartCountBadges(nextQty);

    return nextItems;
  }

  async function syncCartItemsToServer(cartItems, requiredUuid = "") {
    try {
      const result = await postCartItemsToServer(cartItems);

      if (result?.status === "error") {
        const prunedCartItems = removeInvalidCartItems(cartItems, result.IDs, requiredUuid);

        if (prunedCartItems && Object.keys(prunedCartItems).length > 0) {
          const retryResult = await postCartItemsToServer(prunedCartItems);
          syncLocalCartFromServerResponse(retryResult);

          return retryResult;
        }
      }

      syncLocalCartFromServerResponse(result);

      return result;
    } catch (error) {
      console.error("Cart sync to server failed.", error);
      return {
        status: "error",
        message: [getI18n("unable_to_add", "Unable to add this child to your cart.")],
      };
    }
  }

  async function postCartItemsToServer(cartItems) {
    const response = await fetch("/cart/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cart_items: cartItems }),
    });

    if (!response.ok) {
      return {
        status: "error",
        message: [getI18n("unable_to_add", "Unable to add this child to your cart.")],
      };
    }

    return response.json();
  }

  function removeInvalidCartItems(cartItems, invalidItems, requiredUuid = "") {
    if (!Array.isArray(invalidItems) || invalidItems.length === 0) {
      return null;
    }

    const invalidUuids = invalidItems
      .map((item) => String(item?.uuid || ""))
      .filter(Boolean);

    if (invalidUuids.length === 0) {
      return null;
    }

    if (requiredUuid && invalidUuids.includes(String(requiredUuid))) {
      return null;
    }

    const nextItems = { ...(cartItems || {}) };
    let changed = false;

    invalidUuids.forEach((uuid) => {
      if (Object.prototype.hasOwnProperty.call(nextItems, uuid)) {
        delete nextItems[uuid];
        changed = true;
      }
    });

    if (!changed) {
      return null;
    }

    setStoredCartItems(nextItems);
    syncStoredCartQuantity(getCartItemsQuantity(nextItems));

    return nextItems;
  }

  function syncLocalCartFromServerResponse(result) {
    if (!result?.cart?.items || typeof result.cart.items !== "object") {
      return;
    }

    setStoredCartItems(result.cart.items);
    syncStoredCartQuantity(getCartItemsQuantity(result.cart.items));
  }

  function readSponsorDatasetValue(form, key) {
    const wrapper = form.closest("[data-child-primary-cta], [data-child-gravity-form]");

    if (wrapper && wrapper.dataset && wrapper.dataset[key]) {
      return wrapper.dataset[key];
    }

    const primaryCta = form.closest("[data-child-primary-cta]");

    return primaryCta && primaryCta.dataset ? primaryCta.dataset[key] || "" : "";
  }

  function getStoredSponsorshipItems() {
    const cartItems = JSON.parse(localStorage.getItem("cart_items")) ?? {};

    return Object.values(cartItems).filter((item) => {
      return item && item.options && item.options.item_type === "SponsorshipCartItem";
    });
  }

  function getCartItemsQuantity(cartItems) {
    return Object.values(cartItems || {}).reduce((quantity, item) => {
      return quantity + parseInt(item?.quantity || "0", 10);
    }, 0);
  }

  const CART_ITEMS_STORAGE_KEY = "cart_items";
  const CART_QUANTITY_STORAGE_KEY = "cart_qty";
  const CART_MODIFIED_AT_STORAGE_KEY = "cart_items_modified_at";
  const SPONSORSHIP_CART_TTL_MS = 60 * 60 * 1000;

  function parseStoredCartItems() {
    try {
      return JSON.parse(localStorage.getItem(CART_ITEMS_STORAGE_KEY)) ?? {};
    } catch (error) {
      return {};
    }
  }

  function clearStoredCartModifiedAt() {
    localStorage.removeItem(CART_MODIFIED_AT_STORAGE_KEY);
  }

  function setStoredCartModifiedAt(timestamp = Date.now()) {
    localStorage.setItem(CART_MODIFIED_AT_STORAGE_KEY, String(timestamp));
  }

  function setStoredCartItems(cartItems, { touch = true } = {}) {
    const nextItems = cartItems && typeof cartItems === "object" ? cartItems : {};
    const hasItems = Object.keys(nextItems).length > 0;

    if (hasItems) {
      if (!touch) {
        globalThis.planUsaSkipCartModifiedAtTouch = true;
      }

      try {
        localStorage.setItem(CART_ITEMS_STORAGE_KEY, JSON.stringify(nextItems));
      } finally {
        if (!touch) {
          globalThis.planUsaSkipCartModifiedAtTouch = false;
        }
      }
    } else {
      localStorage.removeItem(CART_ITEMS_STORAGE_KEY);
    }

    if (touch && hasItems) {
      setStoredCartModifiedAt();
      return;
    }

    if (!hasItems) {
      clearStoredCartModifiedAt();
    }
  }

  function expireStoredSponsorshipCartItems() {
    const modifiedAt = Number.parseInt(localStorage.getItem(CART_MODIFIED_AT_STORAGE_KEY) || "0", 10);

    if (!modifiedAt || (Date.now() - modifiedAt) <= SPONSORSHIP_CART_TTL_MS) {
      return parseStoredCartItems();
    }

    const cartItems = parseStoredCartItems();
    const nextItems = Object.fromEntries(
      Object.entries(cartItems).filter(([, item]) => item?.options?.item_type !== "SponsorshipCartItem"),
    );

    setStoredCartItems(nextItems, { touch: false });
    clearStoredCartModifiedAt();

    return nextItems;
  }

  function getChildSalesforceId(formData) {
    return String(formData.get("child_id") || formData.get("child_salesforce_id") || "");
  }

  function generateCartItemUuid() {
    let timestamp = new Date().getTime();
    let microtime = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0;

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (character) => {
      let random = Math.random() * 16;

      if (timestamp > 0) {
        random = (timestamp + random) % 16 | 0;
        timestamp = Math.floor(timestamp / 16);
      } else {
        random = (microtime + random) % 16 | 0;
        microtime = Math.floor(microtime / 16);
      }

      return (character === "x" ? random : (random & 0x3) | 0x8).toString(16);
    });
  }

  function pushSponsorshipAddToCart(item) {
    if (typeof dataLayer === "undefined" || !Array.isArray(dataLayer)) {
      return;
    }

    dataLayer.push({
      event: "add_to_cart",
      item: {
        value: Number(item.amount || 0) / 100,
        currency: "USD",
        items: [
          {
            item_id: item.postID,
            item_name: item.name,
            price: Number(item.amount || 0) / 100,
            quantity: Number(item.quantity || 1),
            item_type: item.options?.item_type || "SponsorshipCartItem",
            lo_level_id: item.options?.lo_level_id || "",
            lo_form_id: item.options?.lo_form_id || "",
            installment_frequency: item.options?.installment_frequency || "",
          },
        ],
      },
    });
  }

  if (typeof globalThis.SponsorChildForm !== "function") {
    globalThis.SponsorChildForm = function () {
      return {
        validateSponsorshipForm(form) {
          return validateSponsorshipFormFallback(form);
        },
        sponsorshipFormSubmit(form, keepShopping = false) {
          return sponsorshipFormSubmitFallback(form, keepShopping);
        },
      };
    };
  }

  // type: 'success' = child successfully added (green)
  // type: 'info'    = duplicate child already in cart (blue)
  // type: 'warning' = cart limit, server error, validation errors (amber)
  function showSponsorAlert(cta, message, { isHtml = false, type = 'warning' } = {}) {
    const alertEl = cta.querySelector("[data-child-sponsor-alert]");
    const text = cta.querySelector("[data-child-sponsor-alert-message]");

    if (!alertEl || !text) {
      return;
    }

    // Apply the condition class to the <dialog> element so the SCSS cascade
    // (.child-sponsor-alert.alert-warning / .alert-info) styles the inner panel.
    alertEl.classList.remove('alert-warning', 'alert-info', 'alert-error', 'alert-success');
    alertEl.classList.add('alert-' + type);

    if (isHtml) {
      text.innerHTML = message;
    } else {
      text.textContent = message;
    }

    openOverlay(alertEl);
  }

  function showSponsorSuccess(cta, childName) {
    const firstName = String(childName || '').trim().split(/\s+/)[0];
    const name = firstName || getI18n("this_child", "This child");
    const message = `${escapeHtml(name)} has been successfully added to your sponsorship cart. <a href="/cart">View your cart</a>.`;
    const alert = cta.querySelector("[data-child-sponsor-alert]");

    if (alert) {
      showSponsorAlert(cta, message, { isHtml: true, type: 'success' });
      return;
    }

    const card = cta.closest("[data-child-profile-card]");
    const notice = card ? card.querySelector("[data-child-message]") : null;

    if (!notice) {
      return;
    }

    notice.hidden = false;
    notice.textContent = "";

    const childText = document.createTextNode(`${firstName || getI18n("this_child", "This child")} has been successfully added to your sponsorship cart. `);
    const cartLink = document.createElement("a");
    cartLink.href = "/cart";
    cartLink.textContent = "View your cart";

    notice.appendChild(childText);
    notice.appendChild(cartLink);
    notice.appendChild(document.createTextNode("."));
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function decodeHtmlEntities(value) {
    const text = String(value || "");

    if (!text.includes("&")) {
      return text;
    }

    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;

    return textarea.value;
  }

  const overlayFocusReturnElements = new WeakMap();

  // Singleton backdrop shown behind alert dialogs (they use dialog.show() so
  // have no native ::backdrop — we inject one manually into <body>).
  let alertBackdropEl = null;

  function getOrCreateAlertBackdrop() {
    if (!alertBackdropEl) {
      alertBackdropEl = document.createElement('div');
      alertBackdropEl.className = 'child-sponsor-alert__backdrop';
      alertBackdropEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(alertBackdropEl);

      // Clicking the backdrop closes any open alert
      alertBackdropEl.addEventListener('click', () => {
        const openAlert = document.querySelector('[data-child-sponsor-alert][open]');
        if (openAlert) {
          closeOverlay(openAlert);
        }
      });
    }
    return alertBackdropEl;
  }

  function showAlertBackdrop() {
    getOrCreateAlertBackdrop().classList.add('is-visible');
  }

  function hideAlertBackdrop() {
    if (alertBackdropEl) {
      alertBackdropEl.classList.remove('is-visible');
    }
  }

  function isSponsorAlert(element) {
    return Boolean(element?.hasAttribute?.("data-child-sponsor-alert"));
  }

  // The dialog focusing steps pick the element carrying autofocus first, then
  // fall back to the first focusable descendant — the close button. Point them
  // at the panel instead: tabindex makes it focusable, autofocus wins the
  // lookup, so opening the alert never lands focus on a control.
  function markAlertDialogFocusTarget(element) {
    if (!element.hasAttribute("tabindex")) {
      element.setAttribute("tabindex", "-1");
    }

    if (!element.hasAttribute("autofocus")) {
      element.setAttribute("autofocus", "");
    }
  }

  function setupNativeDialog(element) {
    if (!isNativeDialog(element) || element.dataset.nativeDialogInitialized === "true") {
      return;
    }

    element.dataset.nativeDialogInitialized = "true";

    if (isSponsorAlert(element)) {
      markAlertDialogFocusTarget(element);
    }

    element.addEventListener("close", () => {
      finishOverlayClose(element);
    });

    element.addEventListener("click", (event) => {
      if (event.target === element) {
        closeOverlay(element);
      }
    });
  }

  function openOverlay(element) {
    if (!element) {
      return;
    }

    const activeElement = document.activeElement;

    if (activeElement && typeof activeElement.focus === "function") {
      overlayFocusReturnElements.set(element, activeElement);
    }

    element.hidden = false;

    if (isNativeDialog(element)) {
      element.removeAttribute("aria-hidden");

      if (!element.open) {
        // Alert dialogs use show() — no viewport-blocking backdrop.
        // Sponsor modals use showModal() — full-screen with native backdrop.
        const isAlert = element.hasAttribute("data-child-sponsor-alert");
        if (isAlert && typeof element.show === "function") {
          element.show();
          showAlertBackdrop(); // custom backdrop for non-modal dialogs
        } else if (typeof element.showModal === "function") {
          element.showModal();
        } else {
          element.setAttribute("open", "");
        }
      }
    } else {
      element.setAttribute("aria-hidden", "false");
    }

    syncOverlayBodyState();
    focusOverlayElement(element);
  }

  function closeOverlay(element) {
    if (!element) {
      return;
    }

    if (isNativeDialog(element)) {
      if (element.open && typeof element.close === "function") {
        element.close();
      }

      finishOverlayClose(element);
      return;
    }

    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
    syncOverlayBodyState();
    restoreOverlayFocus(element);
  }

  function finishOverlayClose(element) {
    element.hidden = true;
    element.removeAttribute("open");
    element.setAttribute("aria-hidden", "true");

    // If the closed element was an alert, hide the custom backdrop.
    if (element.hasAttribute("data-child-sponsor-alert")) {
      hideAlertBackdrop();
    }

    syncOverlayBodyState();
    restoreOverlayFocus(element);
  }

  function isNativeDialog(element) {
    return element?.tagName === "DIALOG";
  }

  function syncOverlayBodyState() {
    document.body.classList.toggle("child-sponsor-modal-open", hasOpenOverlay());
  }

  function hasOpenOverlay() {
    // Lock scroll for the full-screen sponsor modal OR when an alert+backdrop is visible.
    return Boolean(
      document.querySelector("[data-child-sponsor-modal][open]") ||
      document.querySelector("[data-child-sponsor-alert][open]")
    );
  }

  function focusOverlayElement(element) {
    // Alerts are announcements, not tasks. Focus the panel itself (see
    // markAlertDialogFocusTarget) so the message is announced without the
    // close button opening in a focused/ringed state.
    if (isSponsorAlert(element)) {
      markAlertDialogFocusTarget(element);

      if (typeof element.focus === "function") {
        element.focus({ preventScroll: true });
      }

      return;
    }

    const focusTarget = element.querySelector(
      "[autofocus], [data-child-modal-close], [data-child-alert-close], button:not([disabled]), [href], input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])",
    );

    if (typeof focusTarget?.focus === "function") {
      focusTarget.focus({ preventScroll: true });
    }
  }

  function restoreOverlayFocus(element) {
    const focusTarget = overlayFocusReturnElements.get(element);
    overlayFocusReturnElements.delete(element);

    if (focusTarget?.isConnected && typeof focusTarget.focus === "function") {
      focusTarget.focus({ preventScroll: true });
    }
  }

  function updateFilterState(card, form, filters, payload) {
    card.dataset.appliedGender = filters.gender || "";
    card.dataset.appliedAge = filters.age || "";
    card.dataset.appliedCountry = filters.country || "";
    card.dataset.displayProductId = String(payload.displayProductId || 0);

    setSelectValue(form, "child_gender", filters.gender || "");
    setSelectValue(form, "child_age", filters.age || "");
    setSelectValue(form, "child_country", filters.country || "");

    const resetLink = form.querySelector("[data-child-filter-reset]");

    if (resetLink) {
      const hasActiveFilters = Boolean(payload.hasActiveFilters);
      resetLink.hidden = !hasActiveFilters;
      resetLink.setAttribute("href", payload.resetUrl || card.dataset.currentPageUrl || globalThis.location.href);
    }
  }

  function setSelectValue(form, name, value) {
    const input = form.querySelector(`[name='${name}']`);

    if (input) {
      input.value = value;

      // Keep Tom Select's rendered control in sync when present.
      // setValue(value, true) — second arg silences the change callback so we
      // don't trigger a redundant filter refresh after an AJAX update.
      if (input.tomselect) {
        input.tomselect.setValue(value, true);
      }
    }
  }

  function clearFilters(form) {
    setSelectValue(form, "child_gender", "");
    setSelectValue(form, "child_age", "");
    setSelectValue(form, "child_country", "");
  }

  function setInputValue(form, name, value) {
    let input = form.querySelector(`[name='${name}']`);

    if (!input && isGravitySponsorForm(form)) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-child-generated-field", "");
      form.appendChild(input);
    }

    if (input) {
      input.value = value;
    }

    const gravityInput = findGravityFieldInput(form, name);

    if (gravityInput && gravityInput !== input) {
      gravityInput.value = value;
    }
  }

  function updateText(element, value) {
    if (element) {
      element.textContent = value;
    }
  }

  /**
   * Update the text of an element while preserving child elements such as
   * the .yel-line span inside the child name heading.
   *
   * When the site is translated (GTranslate / Google Translate widget), the
   * heading's text node gets wrapped in <font> elements. Updating the first
   * text node in place then no longer removes the previous name, so each
   * filter change stacked another name onto the card. Instead, clear the
   * heading entirely (dropping any translation wrappers and stale text) and
   * rebuild it as: new text node + preserved decorative elements.
   */
  function updateChildName(element, value) {
    if (!element) {
      return;
    }

    const preserved = Array.from(element.children).filter(
      (child) => child.tagName !== "FONT"
    );

    element.textContent = "";
    element.appendChild(document.createTextNode(value));
    preserved.forEach((child) => element.appendChild(child));
  }

  function setLoadingState(form, isLoading) {
    const submitButton = form.querySelector("[data-child-filter-submit]");
    const resetButton = form.querySelector("[data-child-filter-reset]");

    if (!submitButton) {
      return;
    }

    const idleLabel = submitButton.dataset.idleLabel || getI18n("update_profile", "Match me with a child");
    const loadingLabel = submitButton.dataset.loadingLabel || getI18n("updating", "Updating...");

    submitButton.disabled = isLoading;
    submitButton.textContent = isLoading ? loadingLabel : idleLabel;

    if (resetButton) {
      resetButton.disabled = isLoading;
    }
  }

  if (typeof globalThis.CartController !== "function") {
    globalThis.CartController = function (data = {}) {
      if (data?.initialErrors?.length) {
        globalThis.history.replaceState({}, document.title, "/cart");
      }

      return {
        isDebug: new URLSearchParams(window.location.search).get("cart_debug") === "1",
        debugMessages: [],
        cart: {
          items: readStoredCartItems(),
          subtotal: 0,
          storage: {},
        },
        hasLoaded: false,
        errors: data.initialErrors ?? [],
        pushDebug(label, payload = null) {
          if (!this.isDebug) {
            return;
          }

          const suffix = payload === null ? "" : " " + JSON.stringify(payload);
          this.debugMessages.unshift(label + suffix);
          this.debugMessages = this.debugMessages.slice(0, 20);
        },
        initSelectPointerFocus() {
          const cart = document.getElementById("cart");

          if (!cart || cart.dataset.selectPointerFocusBound === "1") {
            return;
          }

          cart.dataset.selectPointerFocusBound = "1";

          cart.addEventListener(
            "pointerdown",
            (event) => {
              if (event.pointerType === "mouse" || event.pointerType === "touch") {
                const select = event.target.closest(".plan-cart-item__select");

                if (select) {
                  select.classList.add("is-pointer-focus");
                }
              }
            },
            true
          );

          cart.addEventListener(
            "keydown",
            (event) => {
              if (event.key !== "Tab") {
                return;
              }

              const select = event.target.closest(".plan-cart-item__select");

              if (select) {
                select.classList.remove("is-pointer-focus");
              }
            },
            true
          );

          cart.addEventListener(
            "focusout",
            (event) => {
              const select = event.target.closest(".plan-cart-item__select");

              if (select) {
                select.classList.remove("is-pointer-focus");
              }
            },
            true
          );
        },
        async get() {
          this.cart.items = this.normalizeCartItems(this.cart.items);
          this.persistCart();
          this.pushDebug("Cart loaded from localStorage", {
            itemKeys: Object.keys(this.cart.items || {}),
            itemCount: Object.keys(this.cart.items || {}).length,
          });
          this.initSelectPointerFocus();
          this.observeCart();
          this.subtotal(this.cart.items);
          this.updateCartCounter();
          await this.syncFromServer(this.cart.items);
          this.scheduleCartEnhancements();
        },
        scheduleCartEnhancements() {
          const run = () => {
            this.hydrateSponsorshipItems();

            Object.entries(this.cart.items).forEach(([key, item]) => {
              if (this.shouldLoadFrequencyOptions(item)) {
                this.getFreqOpts(item.postID, key);
              }
            });
          };

          if (typeof globalThis.requestIdleCallback === "function") {
            globalThis.requestIdleCallback(run, { timeout: 2000 });
          } else {
            globalThis.setTimeout(run, 0);
          }
        },
        observeCart() {
          globalThis.addEventListener("storage", () => {
            this.cart.items = readStoredCartItems();
            this.subtotal(this.cart.items);
            this.updateCartCounter();
            this.hydrateSponsorshipItems();
            Object.entries(this.cart.items).forEach(([key, item]) => {
              if (this.shouldLoadFrequencyOptions(item)) {
                this.getFreqOpts(item.postID, key);
              }
            });
          });
        },
        cartHasItems() {
          return Object.values(this.cart.items || {}).some((item) => this.normalizeQuantity(item?.quantity) > 0);
        },
        parseServerCartItems(items) {
          if (!items) {
            return {};
          }

          if (Array.isArray(items)) {
            return items.reduce((parsedItems, item) => {
              if (!item || typeof item !== "object") {
                return parsedItems;
              }

              const key = String(item.uuid || item.id || "");

              if (key) {
                parsedItems[key] = item;
              }

              return parsedItems;
            }, {});
          }

          if (typeof items === "object") {
            return items;
          }

          return {};
        },
        async syncFromServer(localItemsSnapshot = null) {
          const localItems =
            localItemsSnapshot && typeof localItemsSnapshot === "object"
              ? localItemsSnapshot
              : this.cart.items || {};
          const localHadItems = Object.values(localItems).some(
            (item) => this.normalizeQuantity(item?.quantity) > 0,
          );

          try {
            if (localHadItems) {
              await Promise.race([
                this.syncCartState(),
                new Promise((resolve) => {
                  globalThis.setTimeout(resolve, 10000);
                }),
              ]);
            }

            const response = await fetch("/cart/show", {
              credentials: "same-origin",
              headers: {
                Accept: "application/json",
              },
            });

            if (!response.ok) {
              if (localHadItems) {
                this.cart.items = this.normalizeCartItems(localItems);
                this.persistCart();
              }

              return;
            }

            const payload = await response.json();
            const serverItems = this.parseServerCartItems(payload?.items);
            const hasServerItems = Object.keys(serverItems).length > 0;

            if (hasServerItems || !localHadItems) {
              this.cart.items = this.normalizeCartItems(serverItems);
              this.persistCart();
            } else if (localHadItems) {
              this.cart.items = this.normalizeCartItems(localItems);
              this.persistCart();
            }
          } catch (error) {
            if (localHadItems) {
              this.cart.items = this.normalizeCartItems(localItems);
              this.persistCart();
            }
          } finally {
            this.hasLoaded = true;
          }
        },
        subtotal(items) {
          this.cart.subtotal = Object.values(items || {}).reduce((amount, item) => {
            if (!item || Number(item.quantity) < 0) {
              return amount;
            }

            return amount + this.lineSubtotal(item);
          }, 0);
        },
        lineSubtotal(item) {
          if (!item) {
            return 0;
          }

          return this.normalizeAmountToCents(item.amount) * this.normalizeQuantity(item.quantity);
        },
        normalizeCartItems(items) {
          return Object.entries(items || {}).reduce((normalizedItems, [key, item]) => {
            const normalizedItem = {
              ...item,
              amount: this.normalizeAmountToCents(item?.amount),
              quantity: this.normalizeQuantity(item?.quantity),
            };
            const frequencyOptions = this.normalizeFrequencyOptions(
              normalizedItem?.options?.frequency_options || normalizedItem?.freqOpts || [],
            );

            if (frequencyOptions.length) {
              normalizedItem.freqOpts = frequencyOptions;
              normalizedItem.options = normalizedItem.options || {};
              normalizedItem.options.frequency_options = frequencyOptions;
            }

            normalizedItems[key] = normalizedItem;

            return normalizedItems;
          }, {});
        },
        normalizeAmountToCents(amount) {
          return normalizeAmountToCents(amount);
        },
        normalizeQuantity(quantity) {
          const normalizedQuantity = parseInt(quantity || "0", 10);

          return Number.isFinite(normalizedQuantity) ? Math.max(0, normalizedQuantity) : 0;
        },
        isSponsorshipItem(item) {
          return item?.options?.item_type === "SponsorshipCartItem";
        },
        shouldLoadFrequencyOptions(item) {
          return this.isSponsorshipItem(item) && item?.postID && !this.hasFrequencyOptions(item);
        },
        childSalesforceId(item) {
          return String(item?.options?.child_salesforce_id || item?.options?.child_id || "");
        },
        itemTypeLabel(item) {
          const itemType = item?.options?.item_type || "";

          if (itemType === "ProductGiftCartItem") {
            return item?.options?.isSunnyDays == 1 ? getI18n("sunny_days", "Sunny Days") : getI18n("little_treasures", "Little Treasures");
          }

          if (itemType === "SponsorshipCartItem") {
            return "Child sponsorship";
          }

          return itemType.replace("CartItem", "");
        },
        itemDisplayName(item) {
          const itemType = item?.options?.item_type || "";

          if (itemType === "SponsorshipCartItem") {
            return "";
          }

          if (itemType.replace("CartItem", "") === "Donation") {
            return item?.user_facing_form_name || item?.name || "";
          }

          const name = item?.name || "";

          return name ? name + (itemType === "ProductGiftCartItem" ? " for:" : "") : "";
        },
        childName(item) {
          return item?.options?.child_name || item?.options?.childName || item?.name || "";
        },
        childFirstName(item) {
          const options = item?.options || {};
          const storedFirstName = String(options.child_first_name || "").trim();

          if (storedFirstName) {
            return storedFirstName;
          }

          const fullName = String(options.child_name || options.childName || item?.name || "").trim();

          return fullName ? fullName.split(/\s+/)[0] : "";
        },
        childLocation(item) {
          return item?.options?.child_country || item?.options?.child_location || item?.options?.country || "";
        },
        needsSponsorshipHydration(item) {
          return this.isSponsorshipItem(item) && this.childSalesforceId(item) !== "";
        },
        hydrateSponsorshipItems() {
          Object.entries(this.cart.items || {}).forEach(([key, item]) => {
            if (this.needsSponsorshipHydration(item)) {
              this.hydrateSponsorshipItem(key, item);
            }
          });
        },
        hydrateSponsorshipItem(key, item) {
          const childSfid = this.childSalesforceId(item);

          if (!childSfid) {
            return;
          }

          const params = new URLSearchParams({
            child_sfid: childSfid,
          });

          if (item?.options?.cart_source === "gravity_forms" && item?.postID) {
            params.set("gravity_form_id", String(item.postID));
          }

          fetch(`/wp-json/plan/v1/child-profile-card?${params.toString()}`, {
            credentials: "same-origin",
            headers: {
              Accept: "application/json",
            },
          })
            .then((response) => response.ok ? response.json() : null)
            .then((payload) => {
              const child = payload?.child || {};
              const cartItem = this.cart.items[key];

              if (!cartItem || !child || Object.keys(child).length === 0) {
                return;
              }

              cartItem.options = cartItem.options || {};
              let changed = false;

              if (child.name && cartItem.options.child_name !== child.name) {
                cartItem.options.child_name = child.name;
                changed = true;
              }

              const childFirstName = String(child.firstName || "").trim();

              if (childFirstName && cartItem.options.child_first_name !== childFirstName) {
                cartItem.options.child_first_name = childFirstName;
                changed = true;
              }

              if (child.country && cartItem.options.child_country !== child.country) {
                cartItem.options.child_country = child.country;
                changed = true;
              }

              if (child.imageUrl && cartItem.options.image !== child.imageUrl) {
                cartItem.options.image = child.imageUrl;
                changed = true;
              }

              const frequencyOptions = this.normalizeFrequencyOptions(child?.cta?.frequencyOptions || []);

              if (frequencyOptions.length) {
                cartItem.freqOpts = frequencyOptions;
                cartItem.options.frequency_options = frequencyOptions;
                changed = true;
              }

              if (changed) {
                setStoredCartItems(this.cart.items, { touch: false });
              }
            })
            .catch(() => {});
        },
        itemImageAlt(item) {
          if (this.isSponsorshipItem(item)) {
            const firstName = this.childFirstName(item);
            return firstName
              ? getI18n("sponsor", "Sponsor") + " " + firstName
              : getI18n("child_sponsorship", "Child sponsorship");
          }

          return item?.options?.abstract || item?.name || item?.options?.item_type || getI18n("cart_item", "Cart item");
        },
        hasFrequencyOptions(item) {
          return Array.isArray(item?.freqOpts) && item.freqOpts.length > 0;
        },
        normalizeFrequencyOptions(options) {
          if (!Array.isArray(options)) {
            return [];
          }

          return options
            .map((option) => {
              const amount = this.normalizeAmountToCents(option?.amount);
              const levelId = option?.["level-id"] || option?.levelId || "";
              const frequency = String(option?.frequency || "").toLowerCase();

              if (!amount || !levelId || !frequency) {
                return null;
              }

              return {
                ...option,
                amount,
                "level-id": levelId,
                levelId,
                frequency,
              };
            })
            .filter(Boolean);
        },
        formatFrequency(item) {
          const amount = this.normalizeAmountToCents(item?.amount);
          const frequency = this.frequencyLabel(item?.options?.installment_frequency);
          const formattedAmount = amount > 0 ? "$" + (amount / 100).toFixed(2) : "";

          return [formattedAmount, frequency].filter(Boolean).join(" ");
        },
        groupFrequencyLabel(frequency) {
          return this.frequencyLabel(frequency || "one-time");
        },
        subtotalFrequencyLabel(frequency) {
          const normalized = String(frequency || "").trim().toLowerCase();
          const labels = {
            monthly: "Month",
            quarterly: "Quarter",
            annually: "Annual",
          };

          return labels[normalized] || this.frequencyLabel(frequency);
        },
        frequencyUnitLabel(frequency) {
          const normalized = String(frequency || "").trim().toLowerCase();

          if (normalized === "monthly") {
            return "/ month";
          }

          if (normalized === "quarterly") {
            return "/ quarter";
          }

          if (normalized === "annually") {
            return "/ year";
          }

          return "";
        },
        formatCurrency(amount) {
          return "$" + (this.normalizeAmountToCents(amount) / 100).toFixed(2);
        },
        itemGroupKey(item) {
          const frequency = String(item?.options?.installment_frequency || "one-time").toLowerCase();
          const amount = this.normalizeAmountToCents(item?.amount);

          return `${frequency}::${String(amount)}`;
        },
        groupedCartItems() {
          const groups = {};
          const frequencyOrder = {
            monthly: 1,
            quarterly: 2,
            annually: 3,
            "one-time": 4,
          };

          Object.entries(this.cart.items || {}).forEach(([key, item]) => {
            if (this.normalizeQuantity(item?.quantity) <= 0) {
              return;
            }

            const groupKey = this.itemGroupKey(item);

            if (!groups[groupKey]) {
              groups[groupKey] = {
                key: groupKey,
                frequency: String(item?.options?.installment_frequency || "one-time").toLowerCase(),
                amount: this.normalizeAmountToCents(item?.amount),
                items: [],
              };
            }

            groups[groupKey].items.push({ key, item });
          });

          return Object.values(groups)
            .map((group) => ({
              ...group,
              items: group.items.sort((left, right) => {
                return this.primaryItemTitle(left.item).localeCompare(this.primaryItemTitle(right.item));
              }),
            }))
            .sort((left, right) => {
              const leftOrder = frequencyOrder[left.frequency] || 99;
              const rightOrder = frequencyOrder[right.frequency] || 99;

              if (leftOrder !== rightOrder) {
                return leftOrder - rightOrder;
              }

              return left.amount - right.amount;
            });
        },
        groupSubtotal(group) {
          return (group?.items || []).reduce((total, entry) => total + this.lineSubtotal(entry.item), 0);
        },
        itemGroupCountLabel(group) {
          const count = Array.isArray(group?.items) ? group.items.length : 0;
          return `${count} ${count === 1 ? "item" : "items"}`;
        },
        groupCheckoutUrl(group) {
          const checkoutBaseUrl = window.planUsaCartRoutes?.checkout || "/cart/checkout/";
          const params = new URLSearchParams({
            frequency: String(group?.frequency || "one-time"),
            amount: String(this.normalizeAmountToCents(group?.amount)),
          });

          if (this.isDebug) {
            params.set("cart_debug", "1");
          }

          return checkoutBaseUrl + (checkoutBaseUrl.includes("?") ? "&" : "?") + params.toString();
        },
        primaryItemTitle(item) {
          if (this.isSponsorshipItem(item)) {
            return this.childFirstName(item) || "Child sponsorship";
          }

          return this.itemDisplayName(item) || item?.name || this.itemTypeLabel(item);
        },
        secondaryItemTitle(item) {
          if (this.isSponsorshipItem(item)) {
            return this.childLocation(item) || this.itemTypeLabel(item);
          }

          return this.itemTypeLabel(item);
        },
        itemMetaText(item) {
          if (item?.options?.dedication) {
            const prefix = item.options["tribute.type"] === "tribute" ? getI18n("in_honor_of", "In honor of: ") : getI18n("in_memory_of", "In memory of: ");
            return prefix + (item.options["tribute.honoree.name.full"] || "");
          }

          if (Array.isArray(item?.description)) {
            return item.description.join(", ");
          }

          return item?.description || "";
        },
        itemPriceLabel(item) {
          if (!item) {
            return "";
          }

          if (item?.options?.item_type === "ProductCartItem" || item?.options?.item_type === "ProductGiftCartItem") {
            return this.formatCurrency(this.lineSubtotal(item));
          }

          return [this.formatCurrency(item.amount), this.frequencyUnitLabel(item?.options?.installment_frequency)]
            .filter(Boolean)
            .join(" ");
        },
        formatFrequencyOption(option) {
          return [this.formatCurrency(option?.amount), this.groupFrequencyLabel(option?.frequency)].join(" ");
        },
        frequencyLabel(frequency) {
          return String(frequency || "")
            .trim()
            .toLowerCase()
            .split("-")
            .filter(Boolean)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join("-");
        },
        cartErrorMessages(result) {
          if (Array.isArray(result?.message)) {
            return result.message;
          }

          if (result?.message) {
            return [result.message];
          }

          return [getI18n("unable_to_update", "Unable to update your cart. Please review your selections.")];
        },
        getFreqOpts(id, key) {
          if (!id || !this.cart.items[key]) {
            return;
          }

          fetch(`/wp-json/plan/v1/donation-form?id=${encodeURIComponent(id)}`, {
            credentials: "same-origin",
            headers: {
              Accept: "application/json",
            },
          })
            .then((response) => response.json())
            .then((form) => {
              if (!this.cart.items[key]) {
                return;
              }

              const frequencyOptions = this.normalizeFrequencyOptions(form?.data?.amounts || []);

              if (frequencyOptions.length) {
                this.cart.items[key].freqOpts = frequencyOptions;
              } else if (!this.hasFrequencyOptions(this.cart.items[key])) {
                this.cart.items[key].freqOpts = [];
              }
            })
            .catch(() => {
              if (this.cart.items[key]) {
                this.cart.items[key].freqOpts = [];
              }
            });
        },
        updateFrequency(select, key) {
          const item = this.cart.items[key];
          const option = select ? select.options[select.selectedIndex] : null;

          if (!item || !option) {
            return;
          }

          const levelId = option.dataset.level;
          const amount = option.dataset.amount;
          const frequency = option.value;

          if (!levelId || !amount) {
            return;
          }

          item.amount = this.normalizeAmountToCents(amount);
          item.options.lo_level_id = levelId;
          item.options.installment_frequency = frequency;
          this.persistCart();
          this.syncCartState();
        },
        updateDonationFrequency(frequency, key) {
          if (!this.cart.items[key]) {
            return;
          }

          this.cart.items[key].options.installment_frequency = String(frequency || "one-time").toLowerCase();
          this.persistCart();
          this.syncCartState();
        },
        updateProductsMeta(event, key) {
          const item = this.cart.items[key];

          if (!item) {
            return;
          }

          item.quantity = Math.max(0, Number(event.target.value || 0));
          this.persistCart();
          this.syncCartState();
        },
        handleQuantityChanged() {
        },
        remove(key) {
          delete this.cart.items[key];
          this.persistCart();
          this.syncCartState();
        },
        updateCartCounter() {
          const size = Object.values(this.cart.items || {}).reduce((quantity, item) => {
            return quantity + Number(item?.quantity || 0);
          }, 0);
          syncStoredCartQuantity(size);
          return size;
        },
        persistCart() {
          setStoredCartItems(this.cart.items || {});
          this.subtotal(this.cart.items);
          this.updateCartCounter();
        },
        async syncCartState() {
          let result = null;

          try {
            const response = await fetch("/cart/update", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ cart_items: this.cart.items }),
            });

            result = await response.json();
            this.pushDebug("Cart update response", result);

            if (result?.status === "error") {
              if (Array.isArray(result.IDs)) {
                result.IDs.forEach((item) => {
                  if (item?.uuid) {
                    delete this.cart.items[item.uuid];
                  }
                });
              }

              this.persistCart();
              this.errors = this.cartErrorMessages(result);
              return false;
            }

            if (result?.cart?.items) {
              this.cart.items = this.normalizeCartItems(this.parseServerCartItems(result.cart.items));
              this.persistCart();
            }

            this.errors = [];
            return true;
          } catch (error) {
            this.errors = [getI18n("unable_to_update_retry", "Unable to update your cart. Please try again.")];
            this.pushDebug("Cart update failed", { message: error?.message || "Unknown error" });
            return false;
          }
        },
        async updateCart(event = false, _unusedLegacyLoginPortal = false, frequency = "", amount = "") {
          if (event && typeof event.preventDefault === "function") {
            event.preventDefault();
          }

          this.pushDebug("Checkout sync started", {
            frequency,
            amount: this.normalizeAmountToCents(amount),
            itemKeys: Object.keys(this.cart.items || {}),
          });

          const synced = await this.syncCartState();

          if (!synced) {
            return false;
          }

          const checkoutBaseUrl = window.planUsaCartRoutes?.checkout || "/cart/checkout/";
          const checkoutUrl = frequency && amount
            ? `${checkoutBaseUrl}${checkoutBaseUrl.includes("?") ? "&" : "?"}frequency=${encodeURIComponent(String(frequency).toLowerCase())}&amount=${encodeURIComponent(String(this.normalizeAmountToCents(amount)))}`
            : checkoutBaseUrl;

          const finalCheckoutUrl = this.isDebug
            ? checkoutUrl + (checkoutUrl.includes("?") ? "&cart_debug=1" : "?cart_debug=1")
            : checkoutUrl;

          this.pushDebug("Redirecting to checkout", {
            checkoutUrl: finalCheckoutUrl,
          });

          // Donor-portal cart login removed July 2026 (portal moved to
          // external myplan.planusa.org); checkout is guest-based.
          window.location = finalCheckoutUrl;
        },
      };
    };
  }

  globalThis.planUsaClearCart = async function planUsaClearCart() {
    setStoredCartItems({}, { touch: false });
    localStorage.removeItem(CART_QUANTITY_STORAGE_KEY);
    clearStoredCartModifiedAt();
    syncStoredCartQuantity(0);

    try {
      await fetch("/cart/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ cart_items: {} }),
      });
    } catch (error) {
    }

    return "Cart cleared. Reload the page.";
  };

  normalizeStoredCartCount();

  function normalizeStoredCartCount() {
    const cartItems = expireStoredSponsorshipCartItems();
    const quantity = getCartItemsQuantity(cartItems);
    syncStoredCartQuantity(quantity);
  }

  function readStoredCartItems() {
    return expireStoredSponsorshipCartItems();
  }

  function normalizeCartCount(quantity) {
    const parsedQuantity = Number.parseInt(quantity, 10);

    if (Number.isNaN(parsedQuantity) || parsedQuantity < 0) {
      return 0;
    }

    return parsedQuantity;
  }

  function getCheckoutCartUrls() {
    const checkoutUrl = String(globalThis.planUsaCartRoutes?.checkout || "/cart/checkout/");

    return [
      "/checkout/cart/",
      "/cart/checkout/",
      checkoutUrl,
    ];
  }

  function normalizeLegacyCartLinks() {
    const cartUrl = String(globalThis.planUsaCartRoutes?.cart || "/cart/");

    document.querySelectorAll(".header-shopping-cart a[href], .sidebar_cart_label a[href]").forEach((anchor) => {
      anchor.setAttribute("href", cartUrl);
    });
  }

  function syncStoredCartQuantity(quantity) {
    const nextQuantity = normalizeCartCount(quantity);

    localStorage.setItem(CART_QUANTITY_STORAGE_KEY, String(nextQuantity));
    syncCartCountBadges(nextQuantity);
  }

  function readStoredCartQuantity() {
    return normalizeCartCount(localStorage.getItem(CART_QUANTITY_STORAGE_KEY));
  }

  function syncCartCountBadges(quantity) {
    const nextQuantity = normalizeCartCount(quantity);
    const cartSelectors = [
      ".header-shopping-cart a.elementor-icon",
      ".header-shopping-cart a[href]",
    ].join(", ");

    document.querySelectorAll('[x-ref="cartCount"], [x-ref=cartCount]').forEach((cartCount) => {
      cartCount.innerHTML = String(nextQuantity);
      cartCount.style.display = nextQuantity > 0 ? "" : "none";
      cartCount.style.visibility = nextQuantity > 0 ? "" : "hidden";
    });

    document.querySelectorAll(".elementor-button-icon-qty").forEach((cartCount) => {
      cartCount.textContent = String(nextQuantity);
      cartCount.setAttribute("data-counter", String(nextQuantity));
      cartCount.style.display = nextQuantity > 0 ? "" : "none";
      cartCount.style.visibility = nextQuantity > 0 ? "" : "hidden";
    });

    document.querySelectorAll(".plan-cart-count-badge").forEach((badge) => {
      if (badge.closest(".header-shopping-cart")) {
        return;
      }

      badge.remove();
    });

    document.querySelectorAll(cartSelectors).forEach((anchor) => {
      const badgeHost = anchor.querySelector(".elementor-icon") || anchor;

      if (!badgeHost) {
        return;
      }

      if (globalThis.getComputedStyle(badgeHost).position === "static") {
        badgeHost.style.position = "relative";
      }

      let badge = badgeHost.querySelector(".plan-cart-count-badge");

      if (!badge) {
        badge = document.createElement("span");
        badge.className = "plan-cart-count-badge";
        badge.style.position = "absolute";
        badge.style.top = "-8px";
        badge.style.right = "-10px";
        badge.style.display = "flex";
        badge.style.alignItems = "center";
        badge.style.justifyContent = "center";
        badge.style.minWidth = "18px";
        badge.style.height = "18px";
        badge.style.padding = "0 4px";
        badge.style.borderRadius = "999px";
        badge.style.background = "#0072ce";
        badge.style.color = "#fff";
        badge.style.fontSize = "11px";
        badge.style.fontWeight = "700";
        badge.style.lineHeight = "1";
        badge.style.boxShadow = "0 6px 14px rgba(0, 114, 206, 0.22)";
        badge.style.pointerEvents = "none";
        badgeHost.appendChild(badge);
      }

      badge.textContent = String(nextQuantity);
      badge.style.display = nextQuantity > 0 ? "flex" : "none";
      badge.style.visibility = nextQuantity > 0 ? "visible" : "hidden";
    });
  }

  function syncCartCountFromStorage() {
    try {
      const cartItems = expireStoredSponsorshipCartItems();
      const derivedQuantity = getCartItemsQuantity(cartItems);
      const storedQuantity = readStoredCartQuantity();

      if (derivedQuantity > 0 || storedQuantity === 0) {
        syncStoredCartQuantity(derivedQuantity);
        return;
      }

      syncCartCountBadges(storedQuantity);
    } catch (error) {
      syncStoredCartQuantity(0);
    }
  }

  globalThis.planUsaSyncCartCount = function planUsaSyncCartCount(quantity) {
    syncStoredCartQuantity(quantity);
    return normalizeCartCount(quantity);
  };

  document.addEventListener("DOMContentLoaded", () => {
    normalizeLegacyCartLinks();
    syncCartCountFromStorage();
  });

  globalThis.addEventListener("storage", (event) => {
    if (event.key !== CART_QUANTITY_STORAGE_KEY) {
      return;
    }

    syncStoredCartQuantity(event.newValue);
  });

  globalThis.planUsaInitCheckoutComplete = function planUsaInitCheckoutComplete(checkoutGroup) {
    const storedItems = readStoredCartItems();
    const nextItems = {};

    Object.entries(storedItems).forEach(([key, item]) => {
      const itemOptions = item?.options ?? {};
      const itemFrequency = String(itemOptions.installment_frequency || "").toLowerCase();
      const itemAmount = Number(item?.amount ?? 0);
      const matchesGroup = checkoutGroup
        && itemFrequency === String(checkoutGroup.frequency || "").toLowerCase()
        && itemAmount === Number(checkoutGroup.amount || 0);

      if (checkoutGroup && !matchesGroup) {
        nextItems[key] = item;
      }
    });

    const nextQty = Object.values(nextItems).reduce(
      (total, item) => total + Number(item?.quantity ?? 0),
      0,
    );

    setStoredCartItems(checkoutGroup ? nextItems : {}, { touch: false });
    syncStoredCartQuantity(checkoutGroup ? nextQty : 0);
  };

  document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector(".template-cart.plan-order-received[data-checkout-group]");

    if (!root) {
      return;
    }

    globalThis.planUsaInitCheckoutComplete(JSON.parse(root.dataset.checkoutGroup || "null"));
  });

// Remove ' *' from placeholder on checkout form field #input_9_35_2
  if (!/^\/cart\/checkout(\/|$)/.test(window.location.pathname)) return;

  function fixPlaceholder() {
    var field = document.getElementById('input_9_35_2');
    if (field && field.placeholder.includes(' *')) {
      field.placeholder = field.placeholder.replace(' *', '');
      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (fixPlaceholder()) return;

    var observer = new MutationObserver(function () {
      if (fixPlaceholder()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback: disconnect after 10s to avoid lingering observers
    setTimeout(function () { observer.disconnect(); }, 10000);
  });
})();
